import { Model } from '@/models/Model';
export class Label extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Label';
        this.$endpoint = '/labels';
        this.$fillable = ['key', 'value'];
    }
    resolvePrimaryKey() {
        return '';
    }
}
export var LabelKey;
(function (LabelKey) {
    LabelKey["NONE"] = "none";
    LabelKey["HIGHLIGHTED"] = "highlighted";
    LabelKey["BUSY"] = "busy";
    LabelKey["CLOSED"] = "closed";
    LabelKey["OLD"] = "old";
    LabelKey["INACTIVE"] = "inactive";
    LabelKey["FINISHED"] = "finished";
    LabelKey["FUTURE"] = "future";
    LabelKey["DISMISSED"] = "dismissed";
    LabelKey["BUSY_HIGHLIGHTED_OLD"] = "busyHighlightedOld";
    LabelKey["LESSON_DONE"] = "lesson_done";
})(LabelKey || (LabelKey = {}));
